import { render, staticRenderFns } from "./CharacterDetailsView.vue?vue&type=template&id=7ecdd0b3&scoped=true"
import script from "./CharacterDetailsView.vue?vue&type=script&lang=js"
export * from "./CharacterDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecdd0b3",
  null
  
)

export default component.exports